<template>
  <div>
    <div class="mb-1">
      <button
        type="button"
        class="btn btn-sm btn-outline-secondary"
        @click="voltar"
      >
        <feather-icon
          icon="ArrowLeftIcon"
          size="14"
          class="mr-25"
        />
        Voltar para equipamentos
      </button>
    </div>

    <div class="row">
      <div class="col-md-5">
        <b-card no-body>
          <div class="p-1 d-flex align-items-center justify-content-between">
            <h6 class="mb-0">
              Unidades de medida
            </h6>
            <small class="text-muted">pré-definidas</small>
          </div>
          <table class="table table-sm mb-0">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Sigla</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="unidades.length === 0">
                <td
                  colspan="2"
                  class="text-center text-muted py-3"
                >
                  Nenhuma unidade cadastrada.
                </td>
              </tr>
              <tr
                v-for="u in unidades"
                :key="u.id"
              >
                <td>{{ u.name }}</td>
                <td><span class="badge badge-secondary">{{ u.abbreviation }}</span></td>
              </tr>
            </tbody>
          </table>
        </b-card>
      </div>

      <div class="col-md-7">
        <b-card no-body>
          <div class="p-1 d-flex align-items-center justify-content-between">
            <h6 class="mb-0">
              Tipos de equipamento
            </h6>
            <button
              class="btn btn-sm btn-success"
              :disabled="unidades.length === 0"
              @click="abrirTipo()"
            >
              Novo
            </button>
          </div>
          <table class="table table-sm mb-0">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Medida em</th>
                <th class="text-right">
                  Ações
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="tipos.length === 0">
                <td
                  colspan="3"
                  class="text-center text-muted py-3"
                >
                  {{ unidades.length === 0 ? 'Cadastre uma unidade antes.' : 'Nenhum tipo cadastrado.' }}
                </td>
              </tr>
              <tr
                v-for="t in tipos"
                :key="t.id"
              >
                <td>
                  {{ t.name }}
                  <small
                    v-if="t.description"
                    class="text-muted d-block"
                  >{{ t.description }}</small>
                </td>
                <td>{{ t.unit ? `${t.unit.name} (${t.unit.abbreviation})` : '—' }}</td>
                <td class="text-right">
                  <button
                    class="btn btn-sm btn-outline-secondary"
                    @click="abrirTipo(t)"
                  >
                    Editar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </b-card>
      </div>

      <b-modal
        v-model="mostrarTipo"
        :title="tipo.id ? 'Editar tipo' : 'Novo tipo'"
        hide-footer
      >
        <div class="form-group">
          <label>Nome</label>
          <input
            v-model="tipo.name"
            type="text"
            class="form-control"
            maxlength="120"
            placeholder="Cilindro de oxigênio"
          >
        </div>
        <div class="form-group">
          <label>Medida em</label>
          <v-select
            v-model="tipo.unit_id"
            :options="unidades"
            :reduce="u => u.id"
            label="name"
          />
          <small class="text-muted">
            É o tipo que define a unidade — assim ninguém cadastra 500 kg de oxigênio.
          </small>
        </div>
        <div class="form-group">
          <label>Descrição</label>
          <input
            v-model="tipo.description"
            type="text"
            class="form-control"
            maxlength="255"
          >
        </div>
        <div class="text-right">
          <button
            class="btn btn-secondary mr-1"
            @click="mostrarTipo = false"
          >
            Cancelar
          </button>
          <button
            class="btn btn-primary"
            :disabled="salvando"
            @click="salvarTipo"
          >
            Salvar
          </button>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import ApiErrorMixin from '@/mixins/ApiErrorMixin'

export default {
  name: 'EquipmentTypes',
  mixins: [ApiErrorMixin],

  data() {
    return {
      unidades: [],
      tipos: [],
      salvando: false,
      mostrarTipo: false,
      tipo: {
        id: null, name: '', unit_id: null, description: '',
      },
    }
  },

  mounted() {
    this.carregar()
  },

  methods: {
    voltar() {
      const nodeId = this.$route.query.node_id

      if (nodeId) {
        this.$router.push({ name: 'AdminNode', params: { nodeId } })
        return
      }

      this.$router.back()
    },

    async carregar() {
      try {
        const [u, t] = await Promise.all([
          this.$http.get(`${this.$store.state.api}equipment/units`, { params: { all: 1 } }),
          this.$http.get(`${this.$store.state.api}equipment/types`, { params: { all: 1 } }),
        ])
        this.unidades = u.data.data || []
        this.tipos = t.data.data || []
      } catch (e) {
        this.$message('Erro', this.apiErrorText(e, 'Não foi possível carregar os cadastros.'), 'error')
      }
    },

    abrirTipo(t) {
      this.tipo = t
        ? {
          id: t.id, name: t.name, unit_id: t.unit_id, description: t.description || '',
        }
        : {
          id: null, name: '', unit_id: null, description: '',
        }
      this.mostrarTipo = true
    },

    async salvarTipo() {
      this.salvando = true
      try {
        const base = `${this.$store.state.api}equipment/types`
        const corpo = {
          name: this.tipo.name,
          unit_id: this.tipo.unit_id,
          description: this.tipo.description,
        }

        if (this.tipo.id) await this.$http.put(`${base}/${this.tipo.id}`, corpo)
        else await this.$http.post(base, corpo)

        this.mostrarTipo = false
        this.carregar()
      } catch (e) {
        this.$message('Erro', this.apiErrorText(e, 'Não foi possível salvar o tipo.'), 'error')
      } finally {
        this.salvando = false
      }
    },
  },
}
</script>
